import * as React from 'react';
import { AutoprolongHint } from './AutoprolongHint';
import { useSelector } from 'react-redux';
import { selectIsSubscription } from '../../selectors/buyPackageModal';
import { getTypeName } from './utils';

export const AutoprolongHintContainer = () => {
  const isSubscription = useSelector(selectIsSubscription);

  const typeName = getTypeName(isSubscription);

  return <AutoprolongHint typeName={typeName} />;
};
